import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy route: the page moved to /skills. Redirect any open links/bookmarks.
export const Route = createFileRoute("/_authed/sources")({
  beforeLoad: () => {
    throw redirect({ to: "/skills" });
  },
});
